import { useCallback } from "react";
import useCloudSyncStore from "./useCloudSyncStore";
import useCloudSyncWatcher from "./useCloudSyncWatcher";
import { triggerCloudSync } from "../triggerCloudSync";

const SYNC_ENDPOINTS = {
  aws: "/api/aws/ondemand",
  azure: "/api/azure-sync/onDemand",
  gcp: "/api/gcp-sync/manual",
};

export default function useCloudPageSync(cloudProvider, tenantName, onComplete) {
  const normalizedCloud = cloudProvider?.toLowerCase();
  const syncStatus = useCloudSyncStore((state) => state.syncStatus[normalizedCloud] || false);

  useCloudSyncWatcher(normalizedCloud, tenantName, onComplete);

  const handleSync = useCallback(async () => {
    const endpoint = SYNC_ENDPOINTS[normalizedCloud];
    if (!endpoint || !tenantName) {
      return null;
    }

    try {
      return await triggerCloudSync(normalizedCloud, endpoint, tenantName, onComplete);
    } catch (error) {
      console.error(`Error syncing ${normalizedCloud}:`, error);
      throw error;
    }
  }, [normalizedCloud, tenantName, onComplete]);

  return { syncStatus, handleSync };
};
